module.exports = __webpack_public_path__ + "img/2image.5ca30183.png";